import MRoyNav from "../pages/Dashboard/MRoy/CTScanNav";
import MRoyIndex from "../pages/Dashboard/MRoy/CTScanIndex";
import MRoyTestsPage from "../pages/Dashboard/MRoy/CTScanTestsPage";
import PatientMRoyRecordsPage from "../pages/Dashboard/MRoy/PatientCTScanRecordsPage";
import MRoyRecordDetailsPage from "../pages/Dashboard/MRoy/CTScanRecordDetailsPage";

const mRoyRoutes = {
  path: "/mri",
  element: <MRoyNav />,
  children: [
    { path: "/mri", element: <MRoyIndex /> },
    { path: "/mri/tests", element: <MRoyTestsPage /> },
    { path: "/mri/patient-records", element: <PatientMRoyRecordsPage /> },
    { path: "/mri/patient-records/:id", element: <MRoyRecordDetailsPage /> },
  ],
};

export default mRoyRoutes;
